import React, { useImperativeHandle, useRef } from 'react';
import {
  ExternalContentViewProps,
  ExternalContentViewRef,
} from './external-content-view-types';
import { sanitizePostMessageData } from './external-content-security';
import { StyleSheet } from 'react-native';

export const ExternalContentView = React.forwardRef<
  ExternalContentViewRef,
  ExternalContentViewProps
>(({ externalContentName, externalContentURL, onLoad }, ref) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useImperativeHandle(
    ref,
    () => ({
      postMessage: (data: unknown, targetOrigin: string) => {
        const sanitizedData = sanitizePostMessageData(data);
        if (sanitizedData) {
          iframeRef.current?.contentWindow?.postMessage(
            sanitizedData,
            targetOrigin,
          );
        } else {
          console.warn('Unable to sanitize postMessage data', data);
        }
      },
    }),
    [],
  );

  return (
    <iframe
      height="100%"
      loading="lazy"
      onLoad={onLoad}
      ref={iframeRef}
      referrerPolicy="strict-origin-when-cross-origin"
      // Sandbox restrictions to prevent XSS and other attacks
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads"
      src={externalContentURL}
      style={styles.iframe}
      title={externalContentName}
      width="100%"
    />
  );
});

ExternalContentView.displayName = 'ExternalContentView';

const styles = StyleSheet.create({
  iframe: {
    borderWidth: 0,
  },
});
